import { render } from "./SelectColorCode.vue?vue&type=template&id=2140d9f8&scoped=true"
import script from "./SelectColorCode.vue?vue&type=script&lang=js"
export * from "./SelectColorCode.vue?vue&type=script&lang=js"

import "./SelectColorCode.vue?vue&type=style&index=0&id=2140d9f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2140d9f8"]])

export default __exports__